import { render, staticRenderFns } from "./Charte.vue?vue&type=template&id=c99766b2"
var script = {}
import style0 from "./Charte.vue?vue&type=style&index=0&id=c99766b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports